// For now, let's use direct URLs for all environments
// TODO: Set up proper CORS on backend services or deploy proxy server
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isDevelopment = process.env.NODE_ENV === 'development';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: 'https://authorization-545273374205.europe-north2.run.app/login',
    REGISTER: 'https://authorization-545273374205.europe-north2.run.app/register',
    VERIFY_EMAIL: 'https://authorization-545273374205.europe-north2.run.app/verify-email',
    FORGOT_PASSWORD: 'https://authorization-545273374205.europe-north2.run.app/forgot-password',
    VERIFY_RESET_CODE: 'https://authorization-545273374205.europe-north2.run.app/verify-reset-code',
    CHANGE_PASSWORD: 'https://authorization-545273374205.europe-north2.run.app/change-password',
    LINKEDIN_LOGIN: 'https://authorization-545273374205.europe-north2.run.app/linkedin-login',
    GOOGLE_LOGIN: 'https://authorization-545273374205.europe-north2.run.app/google-login',
    VERIFY_TOKEN: 'https://authorization-545273374205.europe-north2.run.app/verify-token',
  },
  CHAT: {
    PROCESS: 'https://go-langgraph-545273374205.europe-north2.run.app/api/process',
    CONVERSATIONS: 'https://go-langgraph-545273374205.europe-north2.run.app/api/conversations',
  },
  JOB_SEARCH: {
    COUNTRIES: 'https://semantics.jobesta.com/api/countries',
    STATES: 'https://semantics.jobesta.com/api/states',
    CITIES: 'https://semantics.jobesta.com/api/cities',
    GEO_SEARCH: 'https://semantics.jobesta.com/api/job/geosearch',
  },
  JOB_TRACKER: {
    BASE_URL: 'https://job-tracker-545273374205.europe-north2.run.app',
  },
  COMPANY_SCRAPPER: {
    BASE_URL: 'https://company-scrapper-545273374205.europe-north2.run.app',
    SCRAPE_JOB: 'https://quota-wrapper-feypx5fx5q-ma.a.run.app/api/v1/scrape-job',
  },
  DOCUMENT_GENERATOR: {
    BASE_URL: 'https://document-generator-545273374205.europe-north2.run.app',
    RESUME_WITHOUT_COMPANY: 'https://quota-wrapper-feypx5fx5q-ma.a.run.app/api/v1/generate-resume-without-company',
    COVER_LETTER_WITHOUT_COMPANY: 'https://quota-wrapper-feypx5fx5q-ma.a.run.app/api/v1/generate-cover-letter-without-company',
  },
  PDF_GENERATOR: {
    BASE_URL: 'https://pdf-generator-545273374205.europe-north2.run.app',
    GENERATE_RESUME_PDF: 'https://quota-wrapper-feypx5fx5q-ma.a.run.app/api/v1/generate-resume-pdf',
    GENERATE_COVER_LETTER_PDF: 'https://quota-wrapper-feypx5fx5q-ma.a.run.app/api/v1/generate-cover-letter-pdf',
  },
  SUBSCRIPTION: {
    BASE_URL: 'https://subscription-545273374205.europe-north2.run.app',
    DETAILS: 'https://subscription-545273374205.europe-north2.run.app/api/subscription-details',
  },
  PAYMENT: {
    BASE_URL: process.env.REACT_APP_PAYMENT_SERVICE_URL || 'https://payment-service-545273374205.europe-north2.run.app',
    CHECKOUT_INIT: process.env.REACT_APP_PAYMENT_SERVICE_URL ? `${process.env.REACT_APP_PAYMENT_SERVICE_URL}/api/checkout/init` : 'https://payment-service-545273374205.europe-north2.run.app/api/checkout/init',
    CANCEL_SUBSCRIPTION: process.env.REACT_APP_PAYMENT_SERVICE_URL ? `${process.env.REACT_APP_PAYMENT_SERVICE_URL}/api/subscription/cancel` : 'https://payment-service-545273374205.europe-north2.run.app/api/subscription/cancel',
    TRANSACTION: process.env.REACT_APP_PAYMENT_SERVICE_URL ? `${process.env.REACT_APP_PAYMENT_SERVICE_URL}/api/transaction` : 'https://payment-service-545273374205.europe-north2.run.app/api/transaction',
  },
  PROFILE_MATCH: {
    MATCH: 'https://quota-wrapper-feypx5fx5q-ma.a.run.app/api/v1/profile-match',
  },
  AI_JOB_SEARCH: {
    LOAD_JOB: 'https://ai-job-search-controller-545273374205.europe-north2.run.app/api/job/load',
  },
};